<button *ngIf="isCobrowseAllowed" (click)="toggleCobrowse.emit(currentWorkItemId)" [ngClass]="{ active: isCobrowseActive }">
  <svg-icon [icon]="'genesys-cobrowse'"></svg-icon>
  <ng2-tooltip
    direction="bottom"
    text="{{ isCobrowseActive ? ('tooltips.gcCobrowseEnd' | translate) : ('tooltips.gcCobrowseStart' | translate) }}"
  ></ng2-tooltip>
</button>

<button
  *ngFor="let i of integrations; trackBy: trackIntegrations"
  (click)="toggleIntegration.emit(i.id)"
  [ngClass]="{ active: isActive(i.id) }"
>
  <svg-icon [icon]="i.svgIconName"></svg-icon>
  <ng2-tooltip direction="bottom" text="{{ i.tooltip | translate }}"></ng2-tooltip>
</button>
